<div *ngIf="event" fxFill fxLayout="column" fxLayoutAlign="space-between center">
  <h1>{{ event.name }}</h1>
  <div style="min-height: 200px;">

  </div>
  <app-guest-edit [eventId]="event.id" fxFill></app-guest-edit>
</div>
